<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard>
                <CCardHeader class="d-flex align-items-center flex-wrap justify-content-between pb-0 header-with-nav">
                    <strong>Файлы экспорта</strong>
                </CCardHeader>
                <CRow>
                    <CCol class="pl-5 pr-5 mt-4">
                        <CSelect
                            :options="list"
                            :value.sync="selected"
                            :horizontal="{input: 'col-sm-12'}"
                            size="sm"
                            style="margin-bottom: 0;"
                        />
                    </CCol>
                </CRow>
                <CCardBody>
                    <ExportTable
                        :list.sync="items"
                        @download="download"
                        @deleteFile="deleteFile"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import ExportTable from '@/components/ExportTable';

    export default {
        name: 'Orders',

        components: {
            ExportTable,
        },

        data() {
            return {
                items: [],
                total: 1,
                timerId: null,
                list: [
                    { value: 'orders', label: 'Отчеты по заказам' },
                    { value: 'partners', label: 'Партнерские отчеты' },
                ],
                selected: 'orders',
            };
        },

        computed: {
        },

        watch: {
            selected(value) {
                this.syncSelectedToRoute(value);
                this.loadData();
            },
            '$route.query.type': {
                immediate: true,
                handler(typeFromRoute) {
                    const normalizedType = this.normalizeType(typeFromRoute);
                    if (this.selected !== normalizedType) {
                        this.selected = normalizedType;
                        return;
                    }
                    this.syncSelectedToRoute(normalizedType);
                }
            }
        },

        mounted() {
            this.timerId = setInterval(this.loadData, 10000);
        },

        beforeDestroy() {
            clearInterval(this.timerId);
        },

        methods: {
            normalizeType(type) {
                const hasType = this.list.some(item => item.value === type);
                return hasType ? type : 'orders';
            },
            syncSelectedToRoute(type) {
                const normalizedType = this.normalizeType(type);
                if (this.$route.query.type === normalizedType) {
                    return;
                }
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        type: normalizedType
                    }
                });
            },
            loadData() {
                Vue.axios
                    .get('/export/orders/status')
                    .then(resp => {
                        this.items = resp.data.filter(status => {
                            const check = status.title.split(/-/)[2]?.includes('EXPORT_ORDERS');
                            if (this.selected === 'orders') {
                                return check;
                            }
                            return !check;
                        });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки файлов. ' + err);
                    });
            },
    
            download(name) {
                this.axios.get(`/export/download/${name}`, { responseType: 'blob' })
                    .then(response => {
                        const isCsv = name?.includes('.csv');
                        let fileURL = window.URL.createObjectURL(response.data);

                        if (isCsv) {
                            const bom = decodeURIComponent('%ef%bb%bf')
                            fileURL = window.URL.createObjectURL(new Blob([bom, response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }));
                        }

                        const fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', isCsv ? `${name}` : `${name}`);
                        document.body.appendChild(fileLink);

                        fileLink.click();
                    });
            },
            async deleteFile(name) {
                try {
                    await this.axios.delete(`/export/delete/${name}`);
                } catch (error) {
                    this.$root.$emit(error)
                } finally {
                    this.loadData();
                }
            },
        },
    };
</script>

<style>
input.custom-datepicker {
  border: 1px solid;
  border-color: #d8dbe0;
  width: 100%;
}
.header-with-nav ul.nav.nav-tabs {
    border-bottom: 0;
}
</style>
